import type { FC } from 'react';

import { SvgIcon, type SvgIconProps } from '../SvgIcon';

export const VideoFormatHorizontalIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 32 32" {...props}>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M30 22L30 10C30 9.20435 29.6839 8.44129 29.1213 7.87868C28.5587 7.31607 27.7956 7 27 7L5 7C4.20435 7 3.44129 7.31607 2.87868 7.87868C2.31607 8.44129 2 9.20435 2 10L2 22C2 22.7956 2.31607 23.5587 2.87868 24.1213C3.44129 24.6839 4.20435 25 5 25L27 25C27.7956 25 28.5587 24.6839 29.1213 24.1213C29.6839 23.5587 30 22.7956 30 22ZM5 23C4.73478 23 4.48043 22.8946 4.29289 22.7071C4.10536 22.5196 4 22.2652 4 22L4 10C4 9.73478 4.10536 9.48043 4.29289 9.29289C4.48043 9.10536 4.73478 9 5 9L27 9C27.2652 9 27.5196 9.10536 27.7071 9.29289C27.8946 9.48043 28 9.73478 28 10L28 22C28 22.2652 27.8946 22.5196 27.7071 22.7071C27.5196 22.8946 27.2652 23 27 23L5 23Z"
      fill="currentColor"
    />
  </SvgIcon>
);
